import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';

/**
 * ChartIcon
 * Ikona grafu pre sekcie so súhrnnými alebo analytickými údajmi.
 */
const ChartIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiBarChart2 className={className} {...props} />
);

export default ChartIcon;

